import { render, staticRenderFns } from "./MemorizeItem.vue?vue&type=template&id=87c57e4e&scoped=true&"
import script from "./MemorizeItem.vue?vue&type=script&lang=js&"
export * from "./MemorizeItem.vue?vue&type=script&lang=js&"
import style0 from "./MemorizeItem.vue?vue&type=style&index=0&id=87c57e4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c57e4e",
  null
  
)

export default component.exports